export enum AttentionType {
    PRACTICE = 'PRACTICE',
    PRACTICE_MODULE = 'PRACTICE_MODULE',
    MODULE = 'MODULE'
}
